// Function index:
//   listNpcs(worldId)         — NPCs in a world.
//   createNpc(worldId, body)  — add an NPC at (q,r).
//   deleteNpc(id)             — remove one.

import { asError, getJson, postJson } from './http.js';
import type { NpcRow } from './types.js';

export const listNpcs = (worldId: number): Promise<{ npcs: NpcRow[] }> =>
  getJson(`/api/worlds/${worldId}/npcs`);

export const createNpc = (worldId: number, body: {
  q: number; r: number; name: string;
  description?: string; archetype?: string; base_state?: unknown;
}) => postJson<{ npc_id: number }>(`/api/worlds/${worldId}/npcs`, body);

export const deleteNpc = async (id: number): Promise<void> => {
  const res = await fetch(`/api/npcs/${id}`, { method: 'DELETE' });
  if (!res.ok) throw await asError(res);
};
